import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'lucide-react';
import { UserRole } from '@nbh/shared';
import { useAuth } from '../auth/AuthProvider';
import { TicketDetail } from '../components/pwa/TicketDetail';

export function TicketPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!id) return <p className="p-4 text-sm text-slate-500">{t('detail.notFound')}</p>;

  return (
    <div>
      <button
        type="button"
        onClick={() => navigate('/')}
        className="flex min-h-[48px] items-center gap-1 bg-transparent px-3 text-sm text-slate-400"
      >
        <ChevronLeft className="size-5" aria-hidden="true" />
        {t('detail.back')}
      </button>

      <TicketDetail
        ticketId={id}
        // Contractors must not be able to post notes their own client then hides.
        canPostInternal={user?.role !== UserRole.ExternalVendor}
      />
    </div>
  );
}
